"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onViewTypeChange = exports.menuListItems = exports.isStepper = exports.initialStepperFormula = exports.emptyRule = exports.emptyPercentageRule = exports.ACTIVE_TYPES = void 0;
var _uuid = require("uuid");
var _utils = require("@trs/utils");
var R = _interopRequireWildcard(require("ramda"));
var _helpers = require("../helpers");
var _constants = require("../constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ACTIVE_TYPES = exports.ACTIVE_TYPES = {
  fixed: 'FIXED',
  percentage: 'PERCENTAGE'
};
var emptyRule = exports.emptyRule = function emptyRule() {
  return {
    value: '',
    label: null,
    key: (0, _uuid.v4)()
  };
};
var isStepper = exports.isStepper = function isStepper(_ref) {
  var stepper = _ref.stepper;
  return !(0, _utils.isBlank)(R.path([ACTIVE_TYPES.fixed, 'steps'], stepper)) || !(0, _utils.isBlank)(R.path([ACTIVE_TYPES.percentage, 'steps'], stepper));
};
var menuListItems = exports.menuListItems = function menuListItems(_ref2) {
  var labels = _ref2.labels,
    actions = _ref2.actions,
    ruleIndex = _ref2.ruleIndex,
    setHasChanges = _ref2.setHasChanges;
  return [{
    name: labels.BUTTON_DELETE,
    icon: 'ion-trash-b',
    onClick: function onClick() {
      actions.deleteRuleFormulas(ruleIndex);
      setHasChanges(true);
    }
  }];
};
var onViewTypeChange = exports.onViewTypeChange = function onViewTypeChange(event, rule) {
  var value = event.target.value;
  var stepper = _objectSpread(_objectSpread({}, rule.stepper), {}, {
    activeType: value
  });
  if ((0, _utils.isBlank)(R.path(['stepper', value, 'steps'], rule))) {
    stepper = _objectSpread(_objectSpread({}, stepper), {}, _defineProperty({}, value, {
      steps: [emptyRule(), emptyRule()]
    }));
    if (value === ACTIVE_TYPES.percentage) {
      stepper[value].steps = [_objectSpread(_objectSpread({}, emptyRule()), {}, {
        aditionalFormulaItems: (0, _helpers.createInitialFormula)(_objectSpread({}, _constants.extendedPlaceholdersTypeMap[1]))
      }), _objectSpread(_objectSpread({}, emptyRule()), {}, {
        aditionalFormulaItems: (0, _helpers.createInitialFormula)(_objectSpread({}, _constants.extendedPlaceholdersTypeMap[1]))
      })];
    }
  }
  return stepper;
};
var emptyPercentageRule = exports.emptyPercentageRule = function emptyPercentageRule() {
  return _objectSpread(_objectSpread({}, emptyRule()), {}, {
    of: ''
  });
};
var initialStepperFormula = exports.initialStepperFormula = function initialStepperFormula(_ref3) {
  var rule = _ref3.rule;
  return rule.length > 0 ? rule : _defineProperty(_defineProperty({
    activeType: ACTIVE_TYPES.fixed
  }, ACTIVE_TYPES.fixed, {
    steps: [emptyRule(), emptyRule()]
  }), ACTIVE_TYPES.percentage, {
    steps: []
  });
};